export const BUSINESS = 'Negocio';
export const DEBTS = 'Deudas';
export const CAR = 'Carro';
export const HOUSEHOLD = 'Vivienda';
export const TRIP = 'Viaje';
export const OTHER = 'Otros';
